import { gql } from '@apollo/client';

export const REORDER_PAINTINGS = gql`
  mutation reorderPaintings($reorders: [ReorderPaintingInput!]!) {
    success: reorderPaintings(reorders: $reorders)
  }
`;
